import { SegmentedControlStack } from './style';
import { SegmentedControlProps } from './types';
import { useKeyboardNavigation } from './useKeyboardNavigation';
import { useSegmentedControlItems } from './useSegmentedControlItems';

export const SegmentedControl = ({
    children,
    value,
    name,
    disabled,
    className,
    size = 'medium',
    itemWidth = 'evenly',
    onChange,
    ...other
}: SegmentedControlProps) => {
    const { itemRefs, childValues, currentValue, renderChildren } = useSegmentedControlItems(
        children,
        value,
        disabled,
        name,
        itemWidth,
        onChange
    );

    const handleKeyDown = useKeyboardNavigation(childValues, currentValue, itemRefs, disabled);

    return (
        <SegmentedControlStack
            className={className}
            size={size}
            role="radiogroup"
            spacing="25"
            distribution="space-between"
            onKeyDown={handleKeyDown}
            {...other}
        >
            {renderChildren()}
        </SegmentedControlStack>
    );
};
